import { ReactElement } from 'react';
import cn from 'classnames';
import styles from './OrderedList.module.scss';
import { getDataTest } from '../../utils/dataTests';

export interface OrderedListProps {
    items: Array<string>;
    className?: string;
}

export const OrderedList = ({ items, className, ...props }: OrderedListProps): ReactElement | null => {
    if (items.length === 0) {
        return null;
    }

    return (
        <ol className={cn(styles.wrapper, className)} {...props}>
            {items.map((item, i) => (
                <li key={i} className={styles.item} data-test={getDataTest(props, `Item[${i}]`)}>
                    <span>{item}</span>
                </li>
            ))}
        </ol>
    );
};
